// import pluralize from 'pluralizer';
const ensureAttribute = (name, object) => {
  if (object == null || name in object === false) {
    throw new Error(`'${name}' property was not found in object and is required`);
  }
};

class JsonApiResourceSerializer {
  isNonEmptyRelationship = relationship =>
    relationship.data != null &&
    (Array.isArray(relationship.data) || Object.keys(relationship.data).length > 0);

  nonEmptyRelationships = relationships =>
    relationships.filter(r => this.isNonEmptyRelationship(r));

  deserializeAttributes(container, item) {
    return { ...container, type: item.type, ...item.attributes, id: item.id };
  }

  recordsForType = (type, records) => records.filter(r => r.type === type);

  resolveRelationship(relationship, records, payload) {
    if (!payload) throw new Error('Payload is required');
    ensureAttribute('type', relationship);
    ensureAttribute('id', relationship);
    const record = this.deserializeItem(
      records.find(r => r.type === relationship.type && r.id === relationship.id),
      payload
    );

    return record;
  }

  mapRelationship(relationship, payload) {
    if (!relationship.data) return null;
    ensureAttribute('data', relationship);
    ensureAttribute('included', payload);
    const { data } = relationship;

    if (Array.isArray(data)) {
      return data.map(r =>
        this.resolveRelationship(r, this.recordsForType(r.type, payload.included), payload)
      );
    }
    if (
      data == null ||
      (Array.isArray(data) && data.length === 0) ||
      Object.keys(data).length === 0
    ) {
      return null;
    }
    return this.resolveRelationship(
      data,
      this.recordsForType(relationship.data.type, payload.included),
      payload
    );
  }

  mapRelationships(item, payload) {
    if ('relationships' in item === false) return {};
    if (!payload) throw new Error('mapRelationships requires a Payload');
    const { relationships } = item;

    return Object.keys(relationships)
      .map(key => {
        return {
          key: key,
          data: this.mapRelationship(relationships[key], payload)
        };
      })
      .reduce((prev, curr) => {
        prev[curr.key] = curr.data;
        return prev;
      }, {});
  }

  deserializeItem(item, payload) {
    if (!payload) throw new Error('A payload is required.');
    if (!item) return {};

    return {
      ...this.deserializeAttributes({}, item),
      ...this.mapRelationships(item, payload)
    };
  }

  deserializeCollection = (collection, payload) =>
    collection.map(i => this.deserializeItem(i, payload));

  deserialize(payload) {
    if (!payload) throw new Error('A payload is required');
    ensureAttribute('data', payload);
    return this[Array.isArray(payload.data) ? 'deserializeCollection' : 'deserializeItem'](
      payload.data,
      payload
    );
  }
}

export default JsonApiResourceSerializer;
